import {onError} from '@apollo/client/link/error'
import {ApolloClient, from, HttpLink, InMemoryCache} from '@apollo/client'
import {setContext} from '@apollo/client/link/context'

const errorLink = onError(({
  graphQLErrors,
  networkError
}) => {
  if (graphQLErrors) {
    console.error('GraphQL ERROR\n', graphQLErrors)
  }

  if (networkError) {
    console.error('Network ERROR\n', networkError)
  }
})

const link = from([
  errorLink,
  new HttpLink({uri: '/graphql'}),
])

const authEnabled = __WEBPACK_ISPROD__ ? globalThis.import_meta_env.OKTA_ENABLED : OKTA_ENABLED

const authLink = setContext((_, {headers}) => {
  try {
    const tokenStorage = localStorage.getItem('okta-token-storage')
    if (!tokenStorage) {
      return { headers }
    }
    
    const parsedStorage = JSON.parse(tokenStorage)
    const token = parsedStorage?.idToken?.idToken
    
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
      }
    }
  } catch (error) {
    console.warn('Failed to retrieve auth token:', error)
    return { headers }
  }
})



const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authEnabled ? authLink.concat(link) : link,

  // no cache options from https://www.apollographql.com/docs/react/api/core/ApolloClient/
  queryDeduplication: false,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache', // 'network-only'
    },
  },
})

export default client
